import { Button } from 'components/button/Button'
import { useCreateDirectiveLogic } from 'components/directive/utils/directiveUtils'
import { Icon, IconName } from 'components/icon'
import { IconWrapper } from 'components/iconWrapper/IconWrapper'
import { Stack } from 'components/Stack'
import { StepsGuideList } from 'components/stepsGuide/StepsGuide'
import { Caption, Title, Title_h3_default } from 'components/Typography'
import { describeSimpleDirectiveFlow } from 'logic/directive/describe'
import { SimpleFlowDirectiveType } from 'logic/directive/types'
import { Trans, useTranslation } from 'next-i18next'
import { FC } from 'react'
import { numberRange, toLowerCase } from 'utils/general'

export type ModernDirectiveGuideProps = {
  directiveType: SimpleFlowDirectiveType
}

const icons: IconName[] = ['TapGesture', 'Print', 'DocumentEdit']

export const ModernDirectiveGuide: FC<ModernDirectiveGuideProps> = (props) => {
  const namespace = `${toLowerCase(props.directiveType)}_lp` as const
  const { directiveType } = props
  const { t } = useTranslation(namespace, {
    keyPrefix: `${namespace}.steps_guide`,
  })

  const analyticsPlace =
    directiveType === 'WILL' ? 'will_lp' : directiveType === 'TRUST' ? 'trust_lp' : undefined

  const { create } = useCreateDirectiveLogic(directiveType, {
    place: analyticsPlace,
  })

  const { getButtonTone, getIconColors } = describeSimpleDirectiveFlow(
    props.directiveType
  ).landingPage()

  const steps = numberRange(3).map((i) => ({
    title: t(`step_${i}.title`),
    desc: t(`step_${i}.desc`),
    visual: (
      <div css={{ width: 'fit-content' }}>
        <IconWrapper
          backgroundColor={getIconColors().backgroundColor}
          iconColor={getIconColors().iconColor}
        >
          <Icon name={icons[i - 1]} />
        </IconWrapper>
      </div>
    ),
  }))

  return (
    <Stack gap="6rem">
      <Stack gap="0.5rem">
        <Caption>
          <Trans t={t} i18nKey="caption" />
        </Caption>
        <Title variant={Title_h3_default}>
          <Trans t={t} i18nKey="title" />
        </Title>
      </Stack>
      <StepsGuideList visualHeight={48} steps={steps} singleLine />

      <Stack css={{ alignItems: 'center' }}>
        <Button type="button" size="large" onClick={create} tone={getButtonTone()}>
          <Trans t={t} i18nKey="start_button" />
        </Button>
      </Stack>
    </Stack>
  )
}
